<template>
    <div class="call-to" v-if="form != undefined && form.formfield.length > 0">
        <div class="call-to__container">
              <h5 class="call-to__header">{{ form.name }}</h5>
              <p class="call-to__text" v-if="description != false">{{ form.description }}</p>
              <form class="call-to__form">
                <div class="form-row">
                    <div
                        class="col-xs-12 col-sm-6 form-col"
                        :class="{'col-sm-12': formField.formfieldtype.type == 'textarea'}"
                        v-for="(formField, index) in form.formfield"
                        :key="index">
                        <!-- <label :for="toCamelCase(formField.name)">{{ formField.name }}:</label> -->
                        <input
                          :type="formField.formfieldtype.type === 'phone' ? 'tel' : formField.formfieldtype.type"
                          class="form-control"
                          :id="toCamelCase(formField.name)"
                          v-model="input[toCamelCase(formField.name)].value"
                          :required="formField.required == 1"
                          v-if="formField.formfieldtype.type != 'textarea'"
                          min="0"
                          :placeholder="formField.name"
                        >
                        <textarea
                          class="form-control"
                          :id="toCamelCase(formField.name)"
                          v-model="input[toCamelCase(formField.name)].value"
                          :required="formField.required == 1"
                          v-else-if="formField.formfieldtype.type == 'textarea'"
                          cols="30" rows="4"
                          :placeholder="formField.name"
                        ></textarea>
                    </div>
                </div>
                
                <div class="checks">
                    <p class="checks__text my-2">
                        Am fost informat(a) despre <router-link to="/politica-de-confidentialitate" class="terms">Politica de Confidentialitate</router-link> a prelucrarii datelor cu caracter personal, declar ca am peste 16 ani si sunt de acord cu prelucrarea datelor cu caracter personal
                    </p>
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" id="comercial" v-model="gdpr.comercial_offer">
                        <label class="form-check-label" for="comercial">pentru ofertare comerciala</label>
                    </div> 
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" id="promotions" v-model="gdpr.promotions">
                        <label class="form-check-label" for="promotions">pentru activitati promotionale: promotii, concursuri, reclame, publicitate</label>
                    </div>
                </div>

                <div class="error text-danger mt-3 text-center" v-if="hasErrors">
                    <p class="error__text mb-1">Va rugam sa corectati urmatoarele erori:</p>
                    <p v-for="(error, index) in errors" :key="index" class="error__message mb-1">{{ error }}</p>
                </div>

                <div class="success text-success mt-3 text-center" v-if="successMessage !== ''">
                    <p class="success__text mb-1"> {{ successMessage }} </p>
                </div>

                <div class="call-to__actions form-col">
                    <button class="btn btn-primary call-to__button mr-2" @click.prevent="onSubmit">Trimite</button>
                    <!-- <button class="btn btn-secondary call-to__button" @click.prevent="onClear">Cancel</button> -->
                </div>
              </form>
        </div>
    </div>
</template>

<script>
//import { required } from 'vuelidate/lib/validators'

export default {
  data() {
    return {
        form: {
            formfield: {}
        },
        gdpr: {
            comercial_offer: false,
            promotions: false
        },
        input: {},
        hasErrors: false,
        errors: [],
        inputSent: {},
        successMessage: ''
    };
  },
  props: {
    id: {},
    description: {}
  },
  created() {
    this.getForm()
  },
  methods: {
    getForm() {
        setTimeout(() => {
            this.$http
              .get(`/form/${localStorage.getItem('formId')}`)
              .then(response => {
                this.form = response.data[0];
                this.form.formfield.sort((a, b) => a.id - b.id)
                this.makeModels();
                
              })
              .catch(e => {
                console.log(e);
              });
        }, 500)
    },
    toCamelCase(str) {
        return str
            .split(' ')
            .map(function(item, index) {
                return index !== 0
                    ? item.charAt(0).toUpperCase() + item.substr(1)
                    : item.charAt(0).toLowerCase() + item.substr(1);
            })
            .join('');
    },
    makeModels() {
        for (let i = 0; i < this.form.formfield.length; i++) {
            this.input[this.toCamelCase(this.form.formfield[i].name)] = {};
            this.input[this.toCamelCase(this.form.formfield[i].name)].name = this.form.formfield[i].name;
            this.input[this.toCamelCase(this.form.formfield[i].name)].value = '';
            this.input[this.toCamelCase(this.form.formfield[i].name)].type = this.form.formfield[i].formfieldtype.type;
            if (this.form.formfield[i].required == 1) {
                this.input[this.toCamelCase(this.form.formfield[i].name)].required = true;
            } else {
                this.input[this.toCamelCase(this.form.formfield[i].name)].required = false;
            }
        }
    },
    checkErrors() {
        this.errors = [];
        for (let i in this.input) {
            if (this.input[i].required === true) {
                if (!this.input[i].value.trim()) {
                  this.errors.push(`${this.input[i].name} este obligatoriu.`);
                }
            }
            if (this.input[i].type === 'email' && this.input[i].value.trim() !== '') {
                if (!(/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(this.input[i].value))) {
                    this.errors.push('Email invalid.') 
                }
            }
            if (this.input[i].type === 'text' && this.input[i].value.trim() !== '') {
                if (this.input[i].value.trim().length < 3) {
                    this.errors.push(`${this.input[i].name} trebuie sa fie de minim 3 caractere.`)
                } else if (!(/^[a-zA-Z]*$/).test(this.input[i].value.trim())) {
                    this.errors.push(`${this.input[i].name} este invalid.`)
                } else if ((/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(this.input[i].value.trim()))) {
                    this.errors.push(`${this.input[i].name} este invalid.`)
                }
            }
            if (this.input[i].type === 'phone' && this.input[i].value.trim() !== '') {
                if(!(/^[0-9.]*$/.test(this.input[i].value.trim())) || this.input[i].value.trim().endsWith('.')) {
                    this.errors.push(`${this.input[i].name} este invalid`)
                }
            }
        }
        if (this.errors.length > 0) this.hasErrors = true
        else this.hasErrors = false
    },
    onSubmit() {
      this.checkErrors();
      if(this.errors.length == 0) {
          for (let i in this.input) {
              if(this.input[i].type === 'email') {
                  this.inputSent['email'] = this.input[i].value    
              } else {
                  this.inputSent[i] = this.input[i].value 
              }
          }
          this.$http.post(`/email/${localStorage.getItem('formId')}`,
          {
              ...this.inputSent
          }).then(response => {
              this.onClear()
              this.successMessage = response.data.success
              setTimeout(() => {this.successMessage = ''}, 3000)
          })
          .catch(e => console.log(e.response.data.errors.email[0]))
          this.$http.post(`/consent`, {
              email: this.inputSent.email,
              form_type: this.form.name,
              comercial_offer: this.gdpr.comercial_offer,
              promotions: this.gdpr.promotions
          }).then(response => {
              console.log(response)
          }).catch(e => console.log(e))
      }

    },
    onClear() {
        for (let i in this.input) {
            this.input[i].value = '';
        }
        this.inputSent = {}
        let form = document.querySelector('.call-to__form')
        form.reset()
    }
  }
};
</script>
